import React from "react";
import style from "./LoginSignup.module.css";
import {
    Box,
    Text,
    Flex,
    Image,
    List,
    ListItem,
    ListIcon,
    CloseButton,
    InputGroup,
    InputLeftAddon,
    Input,
    Select,
    Button,
    Stack,
    Spinner,
    Alert,
    AlertIcon,
} from "@chakra-ui/react";
import { BsCheck } from "react-icons/bs";
import signupHome from "../../Images/Login/signupHome.png";
import { Link, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createUser } from "../../services/userService";
import { setUserData } from "../../Utils/localStorageUtils";
import useCustomNavigate from "../../hooks/useCustomNavigate";


const initialFormData = {
    name: "",
    phone: "",
    email: "",
    role: "",
    reraId: "",
    studentId: "",
};

function Signup() {

    const { goTo } = useCustomNavigate()


    const [formData, setFormData] = React.useState(initialFormData);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [message, setMessage] = React.useState(""); // To store success or error message
    const [show, setShow] = React.useState(true);

    const dispatch = useDispatch();
    const { name, phone, email, role, reraId, studentId } = formData;

    const handleChange = (e) => {
        let { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setLoading(true);
        setError("");
        setMessage(""); // Clear any previous message

        try {
            const payload = {
                name,
                mobile: phone,
                email,
                role,
                rera_id: reraId || undefined,
                student_id: studentId || undefined,
            };

            const response = await createUser(payload); // Call the createUser function

            if (response.success) {
                // Store the user data in localStorage using the utility function
                setUserData(response.data); // Save user data
                setMessage("User created successfully!");
                setShow(false);
                goTo("/otp")
            } else {
                setError(response.message || "Something went wrong.");
            }
        } catch (err) {
            setError(err.response?.data?.message || "Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        show && (
            <Box className={style.loginSignupContainer}>
                <Box></Box>
                <Box>
                    <Box h="100%" position="relative">
                        <CloseButton
                            alignSelf="flex-start"
                            position="absolute"
                            right={0}
                            top={0}
                            onClick={() => goTo("/")}
                        />
                        <Flex flexDirection="row" w="100%" h="100%">
                            <Flex className={style.loginLeftBox}>
                                <Box ml="10%" alignSelf="flex-start">
                                    <Image
                                        src={signupHome}
                                        alt="home"
                                        h="100px"
                                        w="100px"
                                        minH="84px"
                                    />
                                </Box>
                                <Box mt="10px" maxW="80%" w="80%">
                                    <Text fontWeight="600" fontSize="18px" mb="8px">
                                        Sign Up
                                    </Text>
                                    <List spacing={3}>
                                        <ListItem>
                                            <ListIcon as={BsCheck} color="green.500" />
                                            Zero Brokerage.
                                        </ListItem>
                                        <ListItem>
                                            <ListIcon as={BsCheck} color="green.500" />
                                            Thousands of new listings daily.
                                        </ListItem>
                                        <ListItem>
                                            <ListIcon as={BsCheck} color="green.500" />
                                            100 Cr+ Brokerage saved monthly.
                                        </ListItem>
                                    </List>
                                </Box>
                            </Flex>
                            <Box className={style.loginRightBox}>
                                <Box className={style.loginFormContainer}>
                                    <form onSubmit={handleSubmit}>
                                        <Text>Enter details to continue</Text>
                                        {/* Show success or error message */}
                                        {message && (
                                            <Alert status="success" mb="4">
                                                <AlertIcon />
                                                {message}
                                            </Alert>
                                        )}
                                        {error && (
                                            <Alert status="error" mb="4">
                                                <AlertIcon />
                                                {error}
                                            </Alert>
                                        )}
                                        <Stack mt="20px" spacing={3}>
                                            <Input
                                                type="text"
                                                variant="outline"
                                                placeholder="Name"
                                                name="name"
                                                value={name}
                                                onChange={handleChange}
                                                className={style.nameAndEmail}
                                                required
                                            />
                                            <InputGroup>
                                                <InputLeftAddon
                                                    children="+91"
                                                    background="transparent"
                                                />
                                                <Input
                                                    type="number"
                                                    name="phone"
                                                    value={phone}
                                                    onChange={handleChange}
                                                    placeholder="Enter Mobile Number"
                                                    fontSize="14px"
                                                    maxLength="10"
                                                    required
                                                />
                                            </InputGroup>
                                            <Input
                                                type="email"
                                                variant="outline"
                                                placeholder="Enter your email like name@gmail.com"
                                                name="email"
                                                value={email}
                                                onChange={handleChange}
                                                className={style.nameAndEmail}
                                                required
                                            />
                                            <Select
                                                placeholder="Select Role"
                                                name="role"
                                                value={role}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="agent">Agent</option>
                                                <option value="company">Company</option>
                                                <option value="student">Student</option>
                                                <option value="user">User</option>
                                            </Select>
                                            {role === "agent" && (
                                                <Input
                                                    type="text"
                                                    variant="outline"
                                                    placeholder="RERA ID (Optional)"
                                                    name="reraId"
                                                    value={reraId}
                                                    onChange={handleChange}
                                                />
                                            )}
                                            {role === "company" && (
                                                <Input
                                                    type="text"
                                                    variant="outline"
                                                    placeholder="RERA ID (Required)"
                                                    name="reraId"
                                                    value={reraId}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            )}
                                            {role === "student" && (
                                                <Input
                                                    type="text"
                                                    variant="outline"
                                                    placeholder="Student ID (Required)"
                                                    name="studentId"
                                                    value={studentId}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            )}
                                        </Stack>
                                        <Button
                                            type="submit"
                                            className={style.loginButton}
                                            isLoading={loading}
                                        >
                                            Continue
                                        </Button>
                                    </form>
                                    <Text fontSize="12px !important" align="center" mt="5px">
                                        Already have an account?{" "}
                                        <Link to="/login">
                                            <Text color="blue !important" display="inline">
                                                Sign In
                                            </Text>
                                        </Link>
                                    </Text>
                                </Box>
                                <Text className={style.loginFooter}>
                                    By continuing, you agree to our{" "}
                                    <a href="#" target="_blank">
                                        Terms & Conditions
                                    </a>
                                </Text>
                            </Box>
                        </Flex>
                    </Box>
                </Box>
            </Box>
        )
    );
}

export default Signup;
